import { useEffect } from 'react';
import { validateMinMaxProperties } from './validateMinMaxProperties';
export const useValidateMinMaxProperties = (maxLength, minLength, maxValue, minValue, decimalMinLength, decimalMaxLength) => {
  useEffect(() => {
    validateMinMaxProperties(maxLength, minLength, 'Length');
    validateMinMaxProperties(maxValue, minValue, 'Value');
    validateMinMaxProperties(decimalMaxLength, decimalMinLength, 'Decimal length');
  }, [maxLength, minLength, maxValue, minValue, decimalMaxLength, decimalMinLength]);
};